import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer">
      <p>
        {" "}
        <Link to={"/terms-of-use"}>Terms of Use</Link> | <Link to={"/privacy-policy"}>Privacy Policy</Link>
        {" | "}
        <Link to={"/cookie-policy"}>Cookie Policy</Link>
        {" | "}
        <Link to={"/community-guide"}>Community Guidelines</Link> | <Link to={"/safety-guide"}>Safety Guidelines</Link>
        {" | "}
        <Link to={"/child-safety"}>Child Safety</Link>{" "}
      </p>
    </div>
  );
};

export default Footer;
